<script>
export default {
	props: ['isOpen'],
	data() {
		return {
			links: [
				{ to: '/projects', label: 'Projects' },
				{ to: '/about', label: 'About Us' },
				{ to: '/contact', label: 'Contact' },
			],
		};
	},
};
</script>

<template>
	<nav
		:class="isOpen ? 'flex' : 'hidden'"
		class="w-full sm:w-auto flex-col sm:flex-row sm:flex items-start sm:items-center gap-1 sm:gap-8 mt-4 sm:mt-0 py-3 sm:py-0"
	>
		<router-link
			v-for="link in links"
			:key="link.to"
			:to="link.to"
			class="navlink relative font-mono-ui text-sm tracking-[0.12em] uppercase text-ink-muted hover:text-ink transition-colors duration-300 py-1"
			:aria-label="link.label"
			>{{ link.label }}</router-link
		>
	</nav>
</template>

<style scoped>
/* Active-section indicator: a small accent dot beneath the current link. */
.navlink::after {
	content: '';
	position: absolute;
	left: 50%;
	bottom: -6px;
	width: 4px;
	height: 4px;
	border-radius: 9999px;
	background-color: #7c73ff;
	transform: translateX(-50%) scale(0);
	transition: transform 0.25s ease;
}
.navlink.router-link-active::after {
	transform: translateX(-50%) scale(1);
}
</style>
